import React from 'react';
import Wagon from '../../components/Wagon';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';

const topSeatColumns = [
  [1, 2],
  [5, 6, 7],
  [10, 11, 12],
  [15, 16, 17],
  [20, 21, 22],
  [25, 26, 27],
  [30, 31, 32],
  [35, 36, 37],
  [40, 41, 42],
  [45, 46, 47],
  [50, 51, 52],
  [55, 56, 57],
  [60, 61, 62],
  [65, 66, 67],
  [70, 71, 72],
  [75, 76, 77],
];

const seatColumns = [
  [3, 4],
  [8, 9],
  [13, 14],
  [18, 19],
  [23, 24],
  [28, 29],
  [33, 34],
  [38, 39],
  [43, 44],
  [48, 49],
  [53, 54],
  [58, 59],
  [63, 64],
  [68, 69],
  [73, 74],
  [78, 79],
  [80, 81],
];

function VMKTwoThree({
  carriageInfo,
  wagonNumber,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const { isDesktop } = useBooking();
  const { trans } = useTranslation();
  return (
    <div className="wagons">
      <div className="title">
        <h1>
          <span className="font-big">{trans('wagon')}</span>
          {' '}
          {wagonNumber}
        </h1>
      </div>

      {isDesktop
        ? (
          <Wagon
            seatColumns={seatColumns}
            topSeatColumns={topSeatColumns}
            seats={carriageInfo?.seats}
            chosenSeats={chosenSeats}
            setChosenSeats={setChosenSeats}
            wagonNumber={wagonNumber}
            reserveSeat={reserveSeat}
            unReserveSeat={unReserveSeat}
            topTablePositions={[7]}
            bottomTablePositions={[7]}
            toiletClassname="translate-x-10"
            className="w-[836px]"
            topLeftToilet
            bottomLeftToilet
          />
        ) : (
          <div
            style={{
              width: 291 / 2,
              height: 1250 / 2,
            }}
            className="overflow-clip flex justify-center items-center"
          >
            <div className="lg:rotate-0 rotate-90 scale-50">
              <Wagon
                seatColumns={seatColumns}
                topSeatColumns={topSeatColumns}
                seats={carriageInfo?.seats}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                topTablePositions={[7]}
                bottomTablePositions={[7]}
                toiletClassname="translate-x-10"
                className="w-[836px]"
                topLeftToilet
                bottomLeftToilet
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default VMKTwoThree;
